// Lightweight click + page-view tracking helper.
// - Auto-attaches a click listener on any element with [data-track] attribute,
//   reading its value as the event target name.
// - Persists a session_id in localStorage so backend can compute unique sessions.
// - Falls back to no-op if /api/track is unreachable.

import api from "@/lib/api";

const SESSION_KEY = "bs_track_session";

function getSessionId() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = (crypto?.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch { return null; }
}

export function trackPageView(path, extra = {}) {
  try {
    api.post("/track", {
      kind: "page_view",
      path: path || window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      session_id: getSessionId(),
      meta: extra,
    }).catch(() => {});
  } catch {}
}

export function trackClick(target, meta = {}) {
  try {
    api.post("/track", {
      kind: "click",
      path: window.location.pathname,
      target: String(target || "unknown").slice(0, 120),
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
      meta,
    }).catch(() => {});
  } catch {}
}

// Auto-binding — call once at app startup.
let _bound = false;
export function bindAutoClickTracking() {
  if (_bound || typeof document === "undefined") return;
  _bound = true;
  document.addEventListener(
    "click",
    (e) => {
      try {
        const el = e.target?.closest?.("[data-track]");
        if (!el) return;
        const target = el.getAttribute("data-track") || el.getAttribute("data-testid") || el.textContent?.trim()?.slice(0, 40) || "click";
        const meta = {};
        if (el.tagName === "A") meta.href = el.getAttribute("href") || "";
        if (el.tagName === "BUTTON") meta.label = el.textContent?.trim()?.slice(0, 60) || "";
        trackClick(target, meta);
      } catch {}
    },
    true, // capture
  );
}
